import OrderCompleteView from '@/views/user/orders/OrderCompleteView.vue';
import OrdersListing from '@/views/user/orders/OrdersListing.vue';
import OrderDetail from '@/views/user/orders/OrderDetail.vue';

export const userOrderRoutes = [
  {
    path: '/order/:orderId/completed',
    name: 'OrderComplete',
    component: OrderCompleteView,
    meta: { requiresAuth: true },
  },
  {
    path: '/account/orders',
    name: 'OrdersListing',
    component: OrdersListing,
    meta: { requiresAuth: true },
  },
  {
    path: '/account/order/:orderId',
    name: 'OrderDetail',
    component: OrderDetail,
    meta: { requiresAuth: true },
  },
];
